import * as React from 'react';
type IconExigenciaCalidadProps = React.SVGProps<SVGSVGElement>;

export const IconExigenciaCalidad: React.FC<IconExigenciaCalidadProps> = (props) => (
	<svg
		width={64}
		height={60}
		viewBox="0 0 64 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<rect
			x="0.5"
			y="47.8737"
			width="47"
			height="63"
			rx="4.44454"
			transform="rotate(-90 0.5 47.8737)"
			fill="#EBF8F0"
		/>
		<path
			d="M10.5 10.8737L53.5 10.8737"
			stroke="#FFA692"
			stroke-width="3.95968"
			stroke-linecap="round"
		/>
		<path
			d="M10.5 19.8737L53.5 19.8737"
			stroke="#FFA692"
			stroke-width="3.95968"
			stroke-linecap="round"
		/>
		<path
			d="M10.3876 28.5455L28.1656 28.5455"
			stroke="#FFA692"
			stroke-width="3.95968"
			stroke-linecap="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M45.284 43.0756C43.8 43.0756 42.597 44.2786 42.597 45.7626V58.9048C42.597 59.0271 42.6962 59.1264 42.8186 59.1264C42.8631 59.1264 42.9065 59.113 42.9433 59.0879L48.3709 55.3919C48.599 55.2365 48.8989 55.2365 49.1271 55.3919L54.5543 59.0877C54.5913 59.1129 54.635 59.1264 54.6797 59.1264C54.8028 59.1264 54.9026 59.0266 54.9026 58.9035V45.7626C54.9026 44.2786 53.6996 43.0756 52.2156 43.0756H45.284Z"
			fill="#FFA692"
		/>
		<path
			d="M47.5639 27.9687C48.2474 27.3862 49.2526 27.3862 49.9361 27.9687L52.2028 29.9004C52.4957 30.15 52.8599 30.3008 53.2434 30.3314L56.2122 30.5683C57.1073 30.6397 57.8181 31.3506 57.8896 32.2457L58.1265 35.2144C58.1571 35.598 58.3079 35.9622 58.5575 36.2551L60.4892 38.5218C61.0717 39.2053 61.0717 40.2105 60.4892 40.894L58.5575 43.1607C58.3079 43.4536 58.1571 43.8177 58.1265 44.2013L57.8896 47.1701C57.8181 48.0652 57.1073 48.776 56.2122 48.8475L53.2434 49.0844C52.8599 49.115 52.4957 49.2658 52.2028 49.5154L49.9361 51.4471C49.2526 52.0296 48.2474 52.0296 47.5639 51.4471L45.2972 49.5154C45.0043 49.2658 44.6401 49.115 44.2566 49.0844L41.2878 48.8475C40.3927 48.776 39.6819 48.0652 39.6104 47.1701L39.3735 44.2013C39.3429 43.8177 39.1921 43.4536 38.9425 43.1607L37.0108 40.894C36.4283 40.2105 36.4283 39.2053 37.0108 38.5218L38.9425 36.2551C39.1921 35.9622 39.3429 35.598 39.3735 35.2144L39.6104 32.2457C39.6819 31.3506 40.3927 30.6397 41.2878 30.5683L44.2566 30.3314C44.6401 30.3008 45.0043 30.15 45.2972 29.9004L47.5639 27.9687Z"
			fill="#7EAE90"
		/>
		<circle
			cx="48.7497"
			cy="39.708"
			r="7.26811"
			fill="#EBF8F0"
		/>
		<path
			d="M48.294 35.9249C48.4741 35.537 49.0256 35.537 49.2057 35.9249L49.982 37.5963C50.0552 37.754 50.2047 37.8627 50.3774 37.8836L52.2069 38.1053C52.6315 38.1568 52.8019 38.6813 52.4886 38.9724L51.1388 40.2272C51.0115 40.3456 50.9544 40.5214 50.9878 40.692L51.3423 42.5005C51.4245 42.9202 50.9784 43.2444 50.6047 43.0364L48.9942 42.1405C48.8423 42.0559 48.6574 42.0559 48.5055 42.1405L46.895 43.0364C46.5213 43.2444 46.0752 42.9202 46.1574 42.5005L46.5119 40.692C46.5453 40.5214 46.4882 40.3456 46.3609 40.2272L45.0111 38.9724C44.6978 38.6813 44.8682 38.1568 45.2928 38.1053L47.1223 37.8836C47.295 37.8627 47.4445 37.754 47.5177 37.5963L48.294 35.9249Z"
			fill="#7EAE90"
		/>
	</svg>
);

export default IconExigenciaCalidad;
